import React from 'react';
import styled from '@emotion/styled';
import { cx } from '@emotion/css';
import 'external-svg-loader';
import AccessibilityText from '../buttons/AccessibilityText';
import { mqBreakpoints } from '../../system-libraries/styles';
import { pxToRem } from '../../system-libraries/styles/utils';
import Config from '../../system-utils/config-manager';

import { linkButton } from '../../system-libraries/styles/components/buttons';

const Container = styled.div({
  height: pxToRem(24),
  minWidth: pxToRem(137),
  paddingRight: pxToRem(26),
  marginBottom: pxToRem(32),

  [mqBreakpoints.tablet]: {
    minWidth: pxToRem(140),
    paddingRight: pxToRem(90),
  },

  [mqBreakpoints.desktop]: {
    paddingRight: pxToRem(80),
  },
});

const Link = styled.a({
  borderBottomWidth: 0,
  boxShadow: 'none !important',
});

export type FooterLinkData = {
  title: string;
  url: string;
  icon_path: string;
};

export type Props = {
  data: FooterLinkData;
};

export const FooterLink: React.FC<Props> = ({ data }) => {
  if (!data) {
    return null;
  }

  const srMessage = `opens a new tab`;
  const concatTitle = data.title.replace(/ /g, '_');
  const srID = `sr-${concatTitle}`;

  return (
    <Container>
      <Link className={cx(linkButton, 'icon-right', 'bg-dark')} href={data.url} target='_blank' rel='noopener noreferrer' aria-describedby={srID} title={data.title}>
        {data.title}
        <AccessibilityText message={srMessage} srID={srID} />
        <svg data-src={Config.get('image_cdn_base_url') + data.icon_path} />
      </Link>
    </Container>
  );
};
